import { ReportService } from '@/app/reports/share/report.service'
import { ref } from '@vue/composition-api'
import store from '@/store'


export default function reportForm() {

  const devices = ref([])
  const geofences = ref([])
  const inside = ref([
{
  id:"WORK_AREA",
  name:"WORK_AREA"

},
{
  id:"LANDFILL_AREA",
  name:"LANDFILL_AREA"
},
{
  id:"CAMP_AREA",
  name:"CAMP_AREA"
}
  
  


  ])
  const searchoperations=ref([


    {
      id:">",
      name:'greater than'
    },
    {
      id:"<",
      name:"less than"
    },
    {
      id:"=",
      name:"equal"
    }

  ]);



  ReportService.getDevicesOptions({
    type:'device',
    user: store.state.auth.userData.id
  }).then(response => devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name})))


  ReportService.getAreasOptions({
    type:'geofence',
    user: store.state.auth.userData.id
  }).then(response => geofences.value = response.data.map((d)=>({id:d.geofence_id,"name":d.name})))


  return {
    devices,
    geofences,
    inside,
    searchoperations
  }
}
